function getURLVar(key) {
  var value = [];

  var query = String(document.location).split('?');

  if (query[1]) {
    var part = query[1].split('&');

    for (i = 0; i < part.length; i++) {
      var data = part[i].split('=');

      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }

    if (value[key]) {
      return value[key];
    } else {
      return '';
    }
  }
}
function isEmpty( el ){
  return !$.trim(el.html())
}
$(document).ajaxStop(function() {
  function isEmpty( el ){
    return !$.trim(el.html())
  }
  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');      
  }	
});

$(document).ready(function() {

  // sidebar mobile toggle code start 
  if ($(window).width() <=991 ) {

    $('#sidebar-toggle .oc-menu-bar').click(function (e) {
      e.stopPropagation();
      var effect = $(this).closest('#sidebar-toggle.oc-menu').find('.menu-effect').val();
      $('#column-left').addClass('sidebar-toggle');
      $('.sidebar-overlay').toggle();
      if(effect == "none") {
        $('#column-left').toggle();
      }

      if(effect == "fade") {
        $('#column-left').fadeToggle();
      }

      if(effect == "slide") {
        $('#column-left').slideToggle();
      }

    });

    $('#column-left').click(function(e){
      e.stopPropagation();
    });

    $(document.body).click(function(e){
      var effect = $('#sidebar-toggle.oc-menu').find('.menu-effect').val();
      $('.sidebar-overlay').hide();
      console.log(effect);
      if(effect == "none") {
        $('#column-left').hide();
      }
      if(effect == "fade") {
        $('#column-left').fadeOut();
      }
      if(effect == "slide") {
        $('#column-left').slideUp();
      }
    });
  }
  // sidebar mobile toggle code end 


  if ($(".hd1").length) {
    $('.slider-group .col1hd1:first').addClass('hd1slider');
  }
  // product video
  // Fase 2 (sept-2026): magnific-popup ya solo se carga en la plantilla password, así que
  // aquí hay que comprobar antes de llamar. Sin la guarda, el TypeError aborta este
  // $(document).ready entero y —con jQuery 2.1.1, que no aísla los callbacks— impide que
  // se ejecuten los ready posteriores, incluido el que inicializa el slider Nivo de la home.
  if (typeof $.fn.magnificPopup === 'function') {
    $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
  }

  // color swatch js snippet
$('.swatch :radio').change(function() {
  var optionIndex = $(this).closest('.swatch').attr('data-option-index');
  var optionValue = $(this).val();

  // Actualiza el select correspondiente
  $(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change'); // Dispara el cambio del select

  // Actualiza el formulario principal con la variante seleccionada
  updateProductVariant();
});

// Función para actualizar la variante seleccionada
function updateProductVariant() {
  // Obtener el ID de la variante desde la URL
  var urlParams = new URLSearchParams(window.location.search);
  var selectedVariant = urlParams.get('variant'); // Obtener el valor del parámetro "variant"
  
  console.log(selectedVariant);

  if (selectedVariant) {
    fetch(`/products/${productHandle}.js`) // Utiliza el handle correcto
      .then(response => response.json())
      .then(product => {
        var variant = product.variants.find(v => v.id == selectedVariant);
        if (variant) {
          console.log(variant);
          // Actualiza compare_at_price
          if (variant.compare_at_price > variant.price) {
            $('span#comparePrice').html(Shopify.formatMoney(variant.compare_at_price));
          } else {
            $('span#comparePrice').html('');
          }
        }
      })
      .catch(error => console.error('Error al obtener el producto:', error));
  } else {
    console.error('No se encontró el ID de la variante en la URL.');
  }
}


  // product page add to cart - COMMENTED OUT
  // Se maneja completamente desde header-cart.liquid para evitar conflictos
  /*
  $('#button-cart').on('click', function(e) {
    e.preventDefault();
    
    console.log('Add to cart clicked');
    console.log('addToCartWithSidebar available:', typeof window.addToCartWithSidebar);
    
    // Usar la nueva función si está disponible
    if (typeof window.addToCartWithSidebar === 'function') {
      console.log('Using sidebar cart function');
      const formData = $('#form_buy').serialize();
      window.addToCartWithSidebar(formData);
      return;
    }
    
    console.log('Falling back to original method');
    
    // Fallback al método original
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy input[type=\'text\'], #form_buy select'),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart').button('loading');
      },
      complete: function() {
        $('#button-cart').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        } else {
          // Producto añadido exitosamente
          toastr.success('Su producto ha sido añadido al carrito.');
          
          // Marcar para abrir carrito después de recargar
          sessionStorage.setItem('openCartAfterReload', 'true');
          location.reload();
        }

      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning('Variante de artículo ya agregado al carrito.');
                         } else {
                         alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });
  */
  /*
  $('#button-cart-sticky').on('click', function(e) {
    e.preventDefault();
    
    // Usar la nueva función si está disponible
    if (typeof window.addToCartWithSidebar === 'function') {
      const formData = $('#form_buy_sticky').serialize();
      window.addToCartWithSidebar(formData);
      return;
    }
    
    // Fallback al método original
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy input[type=\'text\'], #form_buy_sticky select'),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart-sticky').button('loading');
      },
      complete: function() {
        $('#button-cart-sticky').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        } else {
          // Producto añadido exitosamente
          toastr.success('Su producto ha sido añadido al carrito.');

          // Actualizar el carrito y abrir el sidebar
          $.getJSON('/cart.js', function(cart) {
            // Actualizar contador del carrito
            $('.cart-count').text(cart.item_count);
            
            // Marcar para abrir carrito después de recargar
            sessionStorage.setItem('openCartAfterReload', 'true');
            
            // Recargar para actualizar el contenido del carrito
            location.reload();
          });
        }

      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning('Variante de artículo ya agregado al carrito.');
                         } else {
                         alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  $('#button-cart-buy').on('click', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy input[type=\'text\'], #form_buy select'),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart-buy').button('loading');
      },
      complete: function() {
        $('#button-cart-buy').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        }

        $.getJSON('/cart.js', function(cart) {
          window.location.href="/checkout";
        });

      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning('Variante de artículo ya agregado al carrito.');
                         } else {
                         alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  // Scroll
  var currentP = 0;
  var stickyOffset = 0;
  var stickyOffset1 = 0;

  stickyOffset = $('header').offset().top;
  stickyOffset += $('header').outerHeight();
  stickyOffset += 30;

  if (!isEmpty($('#product-product'))) {
    stickyOffset1 = $('#form_buy').offset().top;
    stickyOffset1 += $('#form_buy').outerHeight();
  }

  // Fase 2 (sept-2026): este handler leía layout ($('header').height(), scrollTop) y escribía
  // clases en el mismo evento, sin throttle, consultando el DOM en cada scroll → layout
  // thrashing (el scroll se sentía "pegado" en escritorio). Ahora los selectores se cachean
  // una vez y el trabajo se agrupa en un requestAnimationFrame por frame.
  // headerH se calculaba en cada evento y no se usaba nunca: eliminado.
  var $fixEls = $('.fix'),
      $fix2Els = $('.fix2'),
      $formBuySticky = $('.form_buy_sticky'),
      hasProductProduct = !isEmpty($('#product-product')),
      scrollTicking = false;

  function updateStickyHeader(){
    scrollTicking = false;

    var scrollP = window.pageYOffset;
    var winInnW = window.innerWidth;

    if(scrollP === currentP){ return; }

    //Sticky header
    if(scrollP >= stickyOffset){
      if( winInnW > 991 ){
        $fixEls.addClass('fix-header');
      }
      $fix2Els.addClass('fix-header2');
    } else {
      if( winInnW > 991 ){
        $fixEls.removeClass('fix-header');
      }
      $fix2Els.removeClass('fix-header2');
    }

    if (hasProductProduct) {
      if(scrollP >= stickyOffset1){
        $formBuySticky.addClass('fix-header2').addClass('fix-header1');
      } else {
        $formBuySticky.removeClass('fix-header1').removeClass('fix-header2');
      }
    }

    currentP = scrollP;
  }

  $(window).scroll(function(){
    if (!scrollTicking) {
      scrollTicking = true;
      window.requestAnimationFrame(updateStickyHeader);
    }
  });



  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');      
  }
  if (!isEmpty($('#product2'))) {
    $('#product2 .option-container').addClass('has-option');      
  }

  // move breadcrumbs
  $("header").after('<div class="breadcrumbs"><div class="container"><div class="inner"></div></div></div>');	
  var breadcrumb = $('ul.breadcrumb');
  var breadcrumbs_container = $('.breadcrumbs .container');
  var breadcrumbs_container_inner = $('.breadcrumbs .container .inner');
  var breadcrumbs = $('.breadcrumbs');
  var page_title = $('#content > h1');
  var category_image = $('.category-image');

  breadcrumb.prependTo(breadcrumbs_container_inner);

  // Highlight any found errors
  $('.text-danger').each(function() {
    var element = $(this).parent().parent();

    if (element.hasClass('form-group')) {
      element.addClass('has-error');
    }
  });

  /* Search - Búsqueda personalizada con algoritmo de relevancia */
  $('#btn-search-category').click(function () {
    var value = $('header #search-by-category input[name=\'q\']').val();
    if(value == "Search all products..." || value ==""){
      jQuery('#search-by-category input[name=\'q\']').focus();
      return false;
    }else {
      // Redirigir a nuestra página de búsqueda personalizada
      var url = '/pages/search-results?q=' + encodeURIComponent(value);
      location = url;
    }
  });

  $('#text-search').on('keydown', function(e) {
    if (e.keyCode == 13) {
      $('#btn-search-category').trigger('click');
    }
  });

  // Inicializar autocomplete para el campo de búsqueda
  $('#text-search').autocomplete({
    'source': function(request, response) {
      var term = request.trim();
      
      if (term.length < 2) {
        response([]);
        return;
      }
      
      // Mostrar estado de carga
      var loadingItem = [{
        'label': 'Buscando...',
        'value': 'loading',
        'loading': true
      }];
      response(loadingItem);
      
      // Realizar búsqueda usando la API de productos de Shopify
      $.ajax({
        url: '/products.json',
        type: 'GET',
        data: {
          'limit': 250  // Aumentar el límite para obtener más productos
        },
        dataType: 'json',
        success: function(data) {
          var suggestions = [];
          
          if (data.products) {
            // Función para normalizar texto (eliminar acentos pero preservar guiones)
            function normalizeText(text) {
              return text.toLowerCase()
                         .normalize('NFD')
                         .replace(/[\u0300-\u036f]/g, '') // Eliminar acentos
                         .replace(/[^\w\s\-]/g, ' ')      // Reemplazar caracteres especiales por espacios (excepto guiones)
                         .replace(/\s+/g, ' ')            // Múltiples espacios por uno solo
                         .trim();
            }
            
            // Filtrar productos que coincidan con el término de búsqueda (mejorado y más flexible)
            var filteredProducts = data.products.filter(function(product) {
              var normalizedTitle = normalizeText(product.title);
              var normalizedSearchTerm = normalizeText(term);
              
              // Dividir el término de búsqueda en palabras individuales
              var searchWords = normalizedSearchTerm.split(' ').filter(function(word) {
                return word.length > 0;
              });
              
              // Verificar si TODAS las palabras aparecen en el título, tags o vendor
              var allWordsMatch = searchWords.every(function(word) {
                var titleMatch = normalizedTitle.indexOf(word) !== -1;
                var tagMatch = product.tags && product.tags.some(function(tag) {
                  return normalizeText(tag).indexOf(word) !== -1;
                });
                var vendorMatch = product.vendor && normalizeText(product.vendor).indexOf(word) !== -1;
                
                return titleMatch || tagMatch || vendorMatch;
              });
              
              return allWordsMatch;
            });
            
            // Función para calcular relevancia mejorada
            function calculateRelevance(product, searchTerm) {
              var title = normalizeText(product.title);
              var searchNormalized = normalizeText(searchTerm);
              var searchWords = searchNormalized.split(' ').filter(function(word) { return word.length > 0; });
              var score = 0;
              var matchedWords = 0;
              
              // Bonus MASIVO por coincidencia exacta de toda la frase
              if (title.indexOf(searchNormalized) !== -1) {
                score += 5000;
              }
              
              // Evaluar cada palabra del término de búsqueda
              searchWords.forEach(function(word) {
                var wordMatched = false;
                
                // Título exacto = palabra completa
                if (title === word) {
                  score += 1000;
                  wordMatched = true;
                }
                // Título empieza con la palabra
                else if (title.indexOf(word) === 0) {
                  score += 500;
                  wordMatched = true;
                }
                // Palabra como palabra completa (con espacios alrededor)
                else if (new RegExp('\\b' + word + '\\b', 'i').test(title)) {
                  score += 300;
                  wordMatched = true;
                }
                // Palabra aparece en cualquier parte
                else if (title.indexOf(word) !== -1) {
                  score += 100;
                  wordMatched = true;
                }
                
                if (wordMatched) {
                  matchedWords++;
                }
              });
              
              // Bonus grande por tener TODAS las palabras
              if (matchedWords === searchWords.length && searchWords.length > 1) {
                score += 2000;
              }
              
              return score;
            }
            
            // Ordenar por relevancia mejorada
            filteredProducts.sort(function(a, b) {
              return calculateRelevance(b, term) - calculateRelevance(a, term);
            });
            
            // Mostrar hasta 10 resultados en lugar de 6
            for (var i = 0; i < Math.min(filteredProducts.length, 10); i++) {
              var product = filteredProducts[i];
              var imageUrl = '';
              
              if (product.images && product.images.length > 0) {
                imageUrl = product.images[0].src.replace('.jpg', '_100x.jpg').replace('.png', '_100x.png');
              }
              
              suggestions.push({
                'label': product.title,
                'value': product.title,
                'url': '/products/' + product.handle,
                'image': imageUrl,
                'price': product.variants && product.variants.length > 0 ? product.variants[0].price : null
              });
            }
          }
          
          // Si no hay resultados, mostrar mensaje
          if (suggestions.length === 0) {
            suggestions.push({
              'label': 'No se encontraron productos',
              'value': 'no-results',
              'noResults': true
            });
          }
          
          response(suggestions);
        },
        error: function() {
          var errorItem = [{
            'label': 'Error en la búsqueda',
            'value': 'error',
            'error': true
          }];
          response(errorItem);
        }
      });
    },
    'select': function(item) {
      if (item.url && !item.loading && !item.noResults && !item.error) {
        window.location.href = item.url;
      }
    }
  });

  // También inicializar autocomplete para el campo de búsqueda de la página de búsqueda
  $('.search-input[name="q"]').autocomplete({
    'source': function(request, response) {
      var term = request.trim();
      
      if (term.length < 2) {
        response([]);
        return;
      }
      
      // Mostrar estado de carga
      var loadingItem = [{
        'label': 'Buscando...',
        'value': 'loading',
        'loading': true
      }];
      response(loadingItem);
      
      // Realizar búsqueda usando la API de productos de Shopify
      $.ajax({
        url: '/products.json',
        type: 'GET',
        data: {
          'limit': 250  // Aumentar el límite para obtener más productos
        },
        dataType: 'json',
        success: function(data) {
          var suggestions = [];
          
          if (data.products) {
            // Función para normalizar texto (eliminar acentos pero preservar guiones)
            function normalizeText(text) {
              return text.toLowerCase()
                         .normalize('NFD')
                         .replace(/[\u0300-\u036f]/g, '') // Eliminar acentos
                         .replace(/[^\w\s\-]/g, ' ')      // Reemplazar caracteres especiales por espacios (excepto guiones)
                         .replace(/\s+/g, ' ')            // Múltiples espacios por uno solo
                         .trim();
            }
            
            // Filtrar productos que coincidan con el término de búsqueda (mejorado y más flexible)
            var filteredProducts = data.products.filter(function(product) {
              var normalizedTitle = normalizeText(product.title);
              var normalizedSearchTerm = normalizeText(term);
              
              // Dividir el término de búsqueda en palabras individuales
              var searchWords = normalizedSearchTerm.split(' ').filter(function(word) {
                return word.length > 0;
              });
              
              // Verificar si alguna palabra del término de búsqueda coincide
              var titleMatch = searchWords.some(function(word) {
                return normalizedTitle.indexOf(word) !== -1;
              });
              
              // También buscar en tags y vendor con la misma flexibilidad
              var tagMatch = product.tags && product.tags.some(function(tag) {
                var normalizedTag = normalizeText(tag);
                return searchWords.some(function(word) {
                  return normalizedTag.indexOf(word) !== -1;
                });
              });
              
              var vendorMatch = product.vendor && searchWords.some(function(word) {
                var normalizedVendor = normalizeText(product.vendor);
                return normalizedVendor.indexOf(word) !== -1;
              });
              
              return titleMatch || tagMatch || vendorMatch;
            });
            
            // Ordenar por relevancia (coincidencias al inicio del título primero)
            filteredProducts.sort(function(a, b) {
              var aNormalizedTitle = normalizeText(a.title);
              var bNormalizedTitle = normalizeText(b.title);
              var normalizedSearchTerm = normalizeText(term);
              
              var aStartsWith = aNormalizedTitle.indexOf(normalizedSearchTerm) === 0 ? 0 : 1;
              var bStartsWith = bNormalizedTitle.indexOf(normalizedSearchTerm) === 0 ? 0 : 1;
              
              return aStartsWith - bStartsWith;
            });
            
            // Mostrar hasta 10 resultados en lugar de 6
            for (var i = 0; i < Math.min(filteredProducts.length, 10); i++) {
              var product = filteredProducts[i];
              var imageUrl = '';
              
              if (product.images && product.images.length > 0) {
                imageUrl = product.images[0].src.replace('.jpg', '_100x.jpg').replace('.png', '_100x.png');
              }
              
              suggestions.push({
                'label': product.title,
                'value': product.title,
                'url': '/products/' + product.handle,
                'image': imageUrl,
                'price': product.variants && product.variants.length > 0 ? product.variants[0].price : null
              });
            }
          }
          
          // Si no hay resultados, mostrar mensaje
          if (suggestions.length === 0) {
            suggestions.push({
              'label': 'No se encontraron productos',
              'value': 'no-results',
              'noResults': true
            });
          }
          
          response(suggestions);
        },
        error: function() {
          var errorItem = [{
            'label': 'Error en la búsqueda',
            'value': 'error',
            'error': true
          }];
          response(errorItem);
        }
      });
    },
    'select': function(item) {
      if (item.url && !item.loading && !item.noResults && !item.error) {
        window.location.href = item.url;
      }
    }
  });

  /* 
  $('#search input[name=\'search\']').parent().find('button').on('click', function() {
    var url = $('base').attr('href') + 'index.php?route=product/search';

    var value = $('header #search input[name=\'search\']').val();

    if (value) {
      url += '&search=' + encodeURIComponent(value);
    }

    location = url;
  });

  $('#search input[name=\'search\']').on('keydown', function(e) {
    if (e.keyCode == 13) {
      $('header #search input[name=\'search\']').parent().find('button').trigger('click');
    }
  });
*/
  // Menu
  $('#menu .dropdown-menu').each(function() {
    var menu = $('#menu').offset();
    var dropdown = $(this).parent().offset();

    var i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('#menu').outerWidth());

    if (i > 0) {
      $(this).css('margin-left', '-' + (i + 10) + 'px');
    }
  });

  // Product List
  $('#list-view').click(function() {
    $('#content .product-grid > .clearfix').remove();

    $('#content .row > .product-grid').attr('class', 'product-layout product-list col-xs-12 product-item');
    $('#grid-view').removeClass('active');
    $('#list-view').addClass('active');

    $(".product-item .item").each(function() {
      var caption_top = $(this).find('.caption-top');
      var caption_inner = $(this).find('.caption >.inner');
      $(this).find('.price-box').appendTo(caption_top);
      $(this).find('.btn-cart').appendTo(caption_top);
      $(this).find('.action-links').appendTo(caption_top);
      $(this).find('.product-name').prependTo(caption_inner);
    });

    localStorage.setItem('display', 'list');

  });

  // Product Grid
  $('#grid-view').click(function() {
    var cols = $('#column-right, #column-left').length;

    if (cols == 2) {
      $('#content .product-list').attr('class', 'product-layout product-grid grid-style col-lg-6 col-md-6 col-sm-6 col-xs-6 product-item');
    } else if (cols == 1) {
      $('#content .product-list').attr('class', 'product-layout product-grid grid-style col-lg-4 col-md-4 col-sm-6 col-xs-6 product-item');
    } else {
      $('#content .product-list').attr('class', 'product-layout product-grid grid-style col-lg-3 col-md-3 col-sm-6 col-xs-6 product-item');
    }

    $('#list-view').removeClass('active');
    $('#grid-view').addClass('active');

    $(".product-item .item").each(function() {
      var images_container = $(this).find('.images-container');
      var caption_top = $(this).find('.caption-top');
      var caption_inner = $(this).find('.caption >.inner');
      $(this).find('.action-links').appendTo(images_container);
      $(this).find('.price-box').appendTo(caption_inner);
      $(this).find('.btn-cart').appendTo(caption_inner);
      $(this).find('.product-name').prependTo(caption_top);
    });


    localStorage.setItem('display', 'grid');

  });

  if (localStorage.getItem('display') == 'list') {
    $('#list-view').trigger('click');
    $('#list-view').addClass('active');
  } else {
    $('#grid-view').trigger('click');
    $('#grid-view').addClass('active');
  }

  // grid-style

  $('.grid-style .item').mouseover(function() {
    $(this).closest('.grid-style').addClass('active');
  });
  $('.grid-style .item').mouseout(function() {
    $(this).closest('.grid-style').removeClass('active');
  });

  // Checkout
  $(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function(e) {
    if (e.keyCode == 13) {
      $('#collapse-checkout-option #button-login').trigger('click');
    }
  });

  // tooltips on hover
  $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});

  // Makes tooltips work on ajax generated content
  $(document).ajaxStop(function() {
    $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});
  });
});

// Cart add remove functions - MEJORADO
var cart = {
  'add': function(product_id, quantity) {
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: 'id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
      dataType: 'json',
      beforeSend: function() {
        var btn = $(this);
        //$('.btn-cart').button('loading');
      },
      complete: function() {
        $('.btn-cart').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();

        if (json['redirect']) {
          location = json['redirect'];
        }

        toastr.success('Su producto ha sido añadido al carrito.');

        // Actualizar el carrito y abrir el sidebar
        $.getJSON('/cart.js', function(cart) {
          // Actualizar contador del carrito
          $('.cart-count').text(cart.item_count);
          
          // Marcar para abrir carrito después de recargar
          sessionStorage.setItem('openCartAfterReload', 'true');
          
          // Recargar para actualizar el contenido del carrito
          location.reload();
        });

      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning('Variante de artículo ya agregado al carrito.');
                         } else {
                         alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  },
  'remove': function(variantId) {
    console.log('cart.remove called with variantId:', variantId);
    
    // Verificar si tenemos el nuevo sistema de carrito disponible
    if (typeof window.cartDrawer !== 'undefined' && window.cartDrawer.removeItem) {
      console.log('Using new cart system for removal');
      window.cartDrawer.removeItem(variantId);
      return;
    }
    
    console.log('Using fallback cart removal system');
    
    // Sistema de respaldo mejorado usando change.js
    $.ajax({
      url: '/cart/change.js',
      type: 'post',
      data: JSON.stringify({
        id: variantId,
        quantity: 0
      }),
      contentType: 'application/json',
      dataType: 'json',
      beforeSend: function() {
        console.log('Removing item from cart...');
      },
      success: function(cart) {
        console.log('Item removed successfully, cart updated:', cart);
        
        // Actualizar contador
        $('.cart-count').text(cart.item_count);
        
        if (getURLVar('route') == '/cart' || getURLVar('route') == '/checkout') {
          location = '/cart';
        } else {
          // Recargar carrito lateral si está visible
          if (document.querySelector('.cart-dropdown-menu.active')) {
            setTimeout(function () {
              location.reload();
            }, 100);
          } else {
            // Solo actualizar contador si el carrito no está visible
            load(cart);
          }
        }
        
        toastr.success('Tu producto fue removido del carrito.');
      },
      error: function(xhr, ajaxOptions, thrownError) {
        console.error('Error removing item:', xhr.responseText);
        alert('Error al eliminar el producto: ' + xhr.responseText);
      }
    });
  }
}

function load(cart){
  $('#cart .dropdown-menu > li:first-child .table > tbody > tr').remove();
  $.each(cart.items, function (index, cartItem) {
    var line = index + 1;
    var cents = "";

    if (cartItem.price % 100 < 10) {
      cents = "0";
    }
    var price = parseInt(cartItem.price / 100) + "." + cents + cartItem.price % 100;

    var cartRemove = 'onclick="cart.remove(\''+cartItem.id+'\')"';
    var cartItem = "<tr><td class='text-center'><a href='" + cartItem.url + "' title='" + cartItem.title + "'><img class='cart-image' src='" + cartItem.image + "' alt='" + cartItem.title + "' title='" + cartItem.title + "'></a></td><td class='text-left info-item'><a class='cart-name' href='" + cartItem.url + "'>" + cartItem.title + "</a><p class='cart-quantity'>" + cartItem.quantity + "&nbsp;×&nbsp;</p><p class='cart-price'><span class='money'>" + Shopify.formatMoney(price) + "</span></p></td><td class='text-center cart-close'><button type='button' "+cartRemove+"' title='Remove' class='btn btn-danger btn-xs'><i class='icon-delete'></i></button></td></tr>";
    $('#cart .dropdown-menu > li:first-child .table > tbody').append(cartItem);
  });
  if (cart.item_count < 1) {
    $('#cart .dropdown-menu > li:first-child .table > tbody').append('<p class="text-center cart-empty">Tu Carrito está vacío.</p>');
                                                                     $('#cart .dropdown-menu li:not(:first-child):last-child').removeClass('show');
    $('#cart .dropdown-menu li:not(:first-child):last-child').addClass('hide');
  } else {
    $('#cart .dropdown-menu p.cart-empty').remove();
    $('#cart .dropdown-menu li:not(:first-child):last-child').removeClass('hide');
    $('#cart .dropdown-menu li:not(:first-child):last-child').addClass('show');
  }
  $('#cart > button #cart-total .txt_number').html(cart.item_count);
  $('#cart > button .total-price').html('<span class=money>'+Shopify.formatMoney(cart.total_price)+'<i class="fas fa-chevron-down"></i></span>');
  $('#cart-subtotal').html('<span class=money>'+Shopify.formatMoney(cart.total_price)+'</span>');
  
}

/* Agree to Terms */
$(document).delegate('.agree', 'click', function(e) {
  e.preventDefault();

  $('#modal-agree').remove();

  var element = this;

  $.ajax({
    url: $(element).attr('href'),
    type: 'get',
    dataType: 'html',
    success: function(data) {
      html  = '<div id="modal-agree" class="modal">';
      html += '  <div class="modal-dialog">';
      html += '    <div class="modal-content">';
      html += '      <div class="modal-header">';
      html += '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
      html += '        <h4 class="modal-title">' + $(element).text() + '</h4>';
      html += '      </div>';
      html += '      <div class="modal-body">' + data + '</div>';
      html += '    </div>';
      html += '  </div>';
      html += '</div>';

      $('body').append(html);

      $('#modal-agree').modal('show');
    }
  });
});


//get message from iframe 
window.addEventListener('message', event => {
    var targetInput = $('input[name^="properties[Color]"]').first();
    if (event.origin.startsWith('https://www.lancopaints.com')) { 
        if(targetInput.length > 0) {
            var selectedColor = event.data;
            var productTitle = document.title || '';
            var productHandle = window.location.pathname.split('/').pop() || '';
            
            // Extraer el código del color del paréntesis (ej: "Chapel Hill (6G1-8)" -> "6G1-8")
            var colorCode = '';
            var parenthesisMatch = selectedColor.match(/\(([^)]+)\)/);
            if (parenthesisMatch && parenthesisMatch[1]) {
                colorCode = parenthesisMatch[1];
            }
            
            // Validación para productos Express, Anti Slip, Esmalte al Agua 2 En 1 y Latex Express
            var isAntiSlipProduct = productTitle.toLowerCase().includes('anti slip') || productHandle.includes('anti-slip');
            var isEsmalteAguaMateProduct = productHandle === 'lanco-esmalte-al-agua-2-en-1-mate-colores-a-eleccion';
            var isEsmalteAguaSatinProduct = productHandle === 'lanco-esmalte-al-agua-2-en-1-sat-n-colores-a-eleccion';
            var isEsmalteAguaSemiBrilloProduct = productHandle === 'lanco-esmalte-al-agua-2-en-1-semi-brillo-colores-a-eleccion';
            var isLatexExpressTinetaProduct = productHandle === 'lanco-latex-express-blanco';
            var isEsmalteSupraMateProduct = productHandle === 'lanco-esmalte-al-agua-supra-mate-disponible-en-multiples-colores';
            var isExpresstinteta4gl = productHandle === 'lanco-latex-express-tineta-4-gl';
            
            var isValidColor = true;
            var errorMessage = '';
            
            if (isAntiSlipProduct) {
                // Para productos Anti Slip: SOLO pueden seleccionar colores que terminen en "-8"
                if (!colorCode.endsWith('-8')) {
                    isValidColor = false;
                    errorMessage = 'Los productos Anti Slip solo admiten colores que terminen en "-8". Por favor selecciona un color compatible.';
                }
            } else if (isEsmalteAguaMateProduct || isEsmalteAguaSatinProduct || isEsmalteAguaSemiBrilloProduct) {
                // Para productos Lanco Esmalte al Agua 2 En 1 (Mate, Satín y Semi Brillo): SOLO pueden seleccionar colores que terminen en "-7"
                if (!colorCode.endsWith('-7')) {
                    isValidColor = false;
                    errorMessage = 'Este producto solo admite colores que terminen en "-7". Por favor selecciona un color compatible.';
                }
            } else if (isLatexExpressTinetaProduct) {
                // Para producto Lanco Latex Express Tineta: SOLO pueden seleccionar colores que terminen en "-5", "-6", "-7", "-8"
                var validEndings = ['-1', '-2', '-3','-5', '-6', '-7'];
                var hasValidEnding = validEndings.some(ending => colorCode.endsWith(ending));
                
                if (!hasValidEnding) {
                    isValidColor = false;
                    errorMessage = 'Este producto solo admite colores que terminen en "-1", "-2", "-3", "-5", "-6" o "-7". Por favor selecciona un color compatible.';
                }
            } else if (isEsmalteSupraMateProduct) {
                // Para producto Lanco Esmalte al Agua Supra Mate: NO pueden seleccionar colores que terminen en "-8" (sin inventario)
                if (colorCode.endsWith('-8')) {
                    isValidColor = false;
                    errorMessage = 'Este producto no tiene disponibilidad de colores que terminen en "-8". Por favor selecciona otro color.';
                }
            }else if(isExpresstinteta4gl) {
                // Para producto Lanco Latex Express Tineta 4 GL: SOLO pueden seleccionar colores que terminen en "-5" o "-7"
                var validEndings = ['-5', '-7'];
                var hasValidEnding = validEndings.some(ending => colorCode.endsWith(ending));
                
                if (!hasValidEnding) {
                    isValidColor = false;
                    errorMessage = 'Este producto solo admite colores que terminen en "-5" o "-7". Por favor selecciona un color compatible.';
                }
            } 
            
            if (isValidColor) {
                targetInput.val(selectedColor);
                targetInput.attr('readonly', true);
                $("#pickerModal").modal("hide");
            } else {
                // Mostrar mensaje de error
                alert(errorMessage);
                console.warn('Color no válido:', selectedColor, 'Código extraído:', colorCode, 'para producto:', isExpressProduct ? 'Express' : (isAntiSlipProduct ? 'Anti Slip' : 'Desconocido'));
                // No cerrar el modal para que el usuario pueda seleccionar otro color
            }
        }
    } else {
        return; 
    } 
});


// show modal on click input
$( document ).ready(function() {
  setTimeout(function(){ 
    var targetInput = $('#openmodal');
    if(targetInput.length > 0) {
      targetInput.click(function() {
        var colorInput = $('input[name^="properties[Color]"]').first();
        // Solo abrir modal si el campo NO contiene "N/A"
        if (colorInput.length > 0 && colorInput.val() !== 'N/A') {
          console.log($('.variant-sku'));
          $('#pickerModal').modal('show');
        }
      });
    } 
  }, 3000);
  var targetInput2 = $('input[name^="properties[Color]"]').first();
  if(targetInput2.length > 0) {
    targetInput2.click(function() {
      // Solo abrir modal si el campo NO contiene "N/A"
      if ($(this).val() !== 'N/A') {
        console.log($('.variant-sku'));
        $('#pickerModal').modal('show');
      }
    });
  } 
});

// add icon before input 

$( document ).ready(function() {
  var targetInput = $('input[name^="properties[Color]"]').first();
  if(targetInput.length > 0) {
   	targetInput.before( "<img id='openmodal' style='display: block;max-width: 58px;margin-bottom: 20px;' src='https://www.lancostore.com/wp-content/uploads/2017/07/circulo-cromatico-12-colores-100x100-1.jpg'>" );
  } 
});

// add color box overlay that covers entire input with absolute positioning

$( document ).ready(function() {
  var targetInput = $('input[name^="properties[Color]"]').first();
  if(targetInput.length > 0) {
    // Crear el contenedor wrapper para posicionamiento relativo
    targetInput.wrap('<div class="color-input-wrapper" style="position: relative; display: inline-block; width: 100%;"></div>');
    
    // Prevenir focus en el input
    targetInput.on('focus', function(e) {
      e.preventDefault();
      $(this).blur();
      console.log('Focus prevented on color input');
    });
    
    // Prevenir clicks directos en el input
    targetInput.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Click prevented on color input');
    });
    
    // Prevenir mousedown en el input
    targetInput.on('mousedown', function(e) {
      e.preventDefault();
      console.log('Mousedown prevented on color input');
    });
    
    // Crear el cuadro de color rojo que cubre todo el input
    var colorOverlay = $('<div class="color-picker-overlay"></div>');
    colorOverlay.css({
      'position': 'absolute',
      'top': '0',
      'left': '0',
      'width': '100%',
      'height': '100%',
      'background-color': 'rgba(231, 76, 60, 0)',
      'cursor': 'pointer',
      'z-index': '10',
      'transition': 'background-color 0.3s ease',
      'border-radius': '4px'
    });
    
    // Añadir efecto hover
    colorOverlay.hover(
      function() {
        $(this).css('background-color', 'rgba(192, 57, 43, 0.3)');
      },
      function() {
        $(this).css('background-color', 'rgba(231, 76, 60, 0)');
      }
    );
    
    // Añadir el overlay al wrapper (después del input)
    targetInput.parent('.color-input-wrapper').append(colorOverlay);
    
    // Funcionalidad del click para abrir el modal
    colorOverlay.click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      var colorInput = $('input[name^="properties[Color]"]').first();
      // Solo abrir modal si el campo NO contiene "N/A"
      if (colorInput.length > 0 && colorInput.val() !== 'N/A') {
        console.log('Opening color picker modal from color overlay');
        $('#pickerModal').modal('show');
      }
    });
  } 
});

// hide custom select color if last option is "Otro"

$( document ).ready(function() {
  console.log('debug 1')
  var lastoption = $('.swatch-element').last().find("input").val();
  var targetInputtohide = $('input[name^="properties[Color]"]').first();
  var imagetohide = $('#openmodal');
  console.log(lastoption);
  if( lastoption == "Otro") {
    targetInputtohide.css("display", "none");
    imagetohide.css("display", "none");
  }
  var skuvariant = $('.variant-sku').text();
  var currgal = $('input[type=radio][name=option-1]').val();

  console.log("debug");
  if($('.variant-sku').text() == 'SD900-5') {
      if(currgal == '1/4 GL') {
        $('.product-customizer-option.option-type-text ').css('display', 'none');
      }
  }
  
    
  setTimeout(function(){ 
    var skuvariant = $('.variant-sku').text();
  var currgal = $('input[type=radio][name=option-1]').val();

  console.log("debug");
  if($('.variant-sku').text() == 'SD900-5') {
      if(currgal == '1/4 GL') {
        $('.product-customizer-option.option-type-text ').css('display', 'none');
      }
  }
    var inputcurrentvalue = $('input[name="option-1"]:checked').val();
    if(inputcurrentvalue == "Otro") {
      targetInputtohide.css("display", "block");
      imagetohide.css("display", "block");
    }
  }, 1000);
});

//
$( document ).ready(function() {
  var targetInputtohide = $('input[name^="properties[Color]"]').first();
  var imagetohide = $('#openmodal');
  var sku = $('');
  $('input[type=radio][name=option-1]').change(function() {
    if($('.variant-sku').text() == 'SD900-5') {
       $('.product-customizer-option.option-type-text ').css('display', 'none');
  }else if($('.variant-sku').text() == 'SD900-4') {
       $('.product-customizer-option.option-type-text ').css('display', 'block');
  }
    console.log('debug');
      if (this.value == 'Otro') {
		targetInputtohide.css("display", "block");
        imagetohide.css("display", "block");
      }else {
        targetInputtohide.css("display", "block");
          imagetohide.css("display", "block");
      } 
  });
});
//

// Autocomplete */
(function($) {
  $.fn.autocomplete = function(option) {
    return this.each(function() {
      this.timer = null;
      this.items = new Array();

      $.extend(this, option);

      $(this).attr('autocomplete', 'off');

      // Focus
      $(this).on('focus', function() {
        this.request();
      });

      // Blur
      $(this).on('blur', function() {
        setTimeout(function(object) {
          object.hide();
        }, 200, this);
      });

      // Keydown
      $(this).on('keydown', function(event) {
        switch(event.keyCode) {
          case 27: // escape
            this.hide();
            break;
          default:
            this.request();
            break;
        }
      });

      // Click
      this.click = function(event) {
        event.preventDefault();

        var target = $(event.target);
        var linkElement = target.closest('a[href]');
        
        if (linkElement.length && linkElement.attr('href') !== '#') {
          // Si es un enlace válido, ir directamente a la URL
          window.location.href = linkElement.attr('href');
          return;
        }
        
        // Fallback al método original
        value = target.closest('li').attr('data-value');

        if (value && this.items[value]) {
          this.select(this.items[value]);
        }
      }

      // Show
      this.show = function() {
        var pos = $(this).position();

        $(this).siblings('ul.dropdown-menu').css({
          top: pos.top + $(this).outerHeight(),
          left: pos.left
        });

        $(this).siblings('ul.dropdown-menu').show();
      }

      // Hide
      this.hide = function() {
        $(this).siblings('ul.dropdown-menu').hide();
      }

      // Request
      this.request = function() {
        clearTimeout(this.timer);

        this.timer = setTimeout(function(object) {
          object.source($(object).val(), $.proxy(object.response, object));
        }, 200, this);
      }

      // Response
      this.response = function(json) {
        html = '';

        if (json.length) {
          for (i = 0; i < json.length; i++) {
            this.items[json[i]['value']] = json[i];
          }

          for (i = 0; i < json.length; i++) {
            if (!json[i]['category']) {
              var item = json[i];
              
              // Estados especiales
              if (item.loading) {
                html += '<li data-value="' + item.value + '" class="loading"><a href="#"><div class="search-autocomplete-item">🔍 ' + item.label + '</div></a></li>';
                continue;
              }
              
              if (item.noResults) {
                html += '<li data-value="' + item.value + '" class="no-results"><a href="#"><div class="search-autocomplete-item">❌ ' + item.label + '</div></a></li>';
                continue;
              }
              
              if (item.error) {
                html += '<li data-value="' + item.value + '" class="error"><a href="#"><div class="search-autocomplete-item">⚠️ ' + item.label + '</div></a></li>';
                continue;
              }
              
              // Elementos normales de producto
              var imageHtml = '';
              var priceHtml = '';
              
              // Agregar imagen si está disponible
              if (item.image) {
                imageHtml = '<img src="' + item.image + '" alt="' + item.label + '" class="search-autocomplete-image">';
              }
              
              // Agregar precio si está disponible
              if (item.price) {
                // Format Chilean peso correctly with thousands separators
                var priceNumber = parseInt(item.price);
                var formattedNumber = priceNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                var formattedPrice = '$' + formattedNumber;
                priceHtml = '<div class="search-autocomplete-price">' + formattedPrice + '</div>';
              }
              
              html += '<li data-value="' + item.value + '">' +
                       '<a href="' + (item.url || '#') + '">' +
                         '<div class="search-autocomplete-item">' +
                           imageHtml +
                           '<div class="search-autocomplete-content">' +
                             '<div class="search-autocomplete-title">' + item.label + '</div>' +
                             priceHtml +
                           '</div>' +
                         '</div>' +
                       '</a>' +
                     '</li>';
            }
          }

          // Get all the ones with a categories
          var category = new Array();

          for (i = 0; i < json.length; i++) {
            if (json[i]['category']) {
              if (!category[json[i]['category']]) {
                category[json[i]['category']] = new Array();
                category[json[i]['category']]['name'] = json[i]['category'];
                category[json[i]['category']]['item'] = new Array();
              }

              category[json[i]['category']]['item'].push(json[i]);
            }
          }

          for (i in category) {
            html += '<li class="dropdown-header">' + category[i]['name'] + '</li>';

            for (j = 0; j < category[i]['item'].length; j++) {
              html += '<li data-value="' + category[i]['item'][j]['value'] + '"><a href="#">&nbsp;&nbsp;&nbsp;' + category[i]['item'][j]['label'] + '</a></li>';
            }
          }
        }

        if (html) {
          this.show();
        } else {
          this.hide();
        }

        $(this).siblings('ul.dropdown-menu').html(html);
      }

      $(this).after('<ul class="dropdown-menu"></ul>');
      $(this).siblings('ul.dropdown-menu').delegate('a', 'click', $.proxy(this.click, this));

    });
  }
})(window.jQuery);

// Función auxiliar para validar campos custom adicionales
function validateCustomFields(form) {
  let isValid = true;
  
  // Validar campo de color específico si está presente y es requerido
  const colorField = form.querySelector('input[name^="properties[Color]"]');
  if (colorField) {
    const colorContainer = colorField.closest('.form-group, .product-customizer-option');
    
    // Si el campo tiene clase 'required' o atributo required
    if (colorField.hasAttribute('required') || (colorContainer && colorContainer.classList.contains('required'))) {
      if (!colorField.value || colorField.value.trim() === '') {
        isValid = false;
        if (colorContainer) {
          colorContainer.classList.add('has-error');
          // Agregar mensaje de error si no existe
          if (!colorContainer.querySelector('.error-message')) {
            const errorMsg = document.createElement('div');
            errorMsg.className = 'error-message';
            errorMsg.style.color = '#ff5d5d';
            errorMsg.style.fontSize = '12px';
            errorMsg.style.marginTop = '5px';
            errorMsg.textContent = 'Por favor selecciona un color.';
            colorContainer.appendChild(errorMsg);
          }
        }
      } else {
        if (colorContainer) {
          colorContainer.classList.remove('has-error');
          // Remover mensaje de error si existe
          const errorMsg = colorContainer.querySelector('.error-message');
          if (errorMsg) {
            errorMsg.remove();
          }
        }
      }
    }
  }
  
  return isValid;
}

// Extender la validación global
if (typeof window.validateProductCustomizerFields === 'function') {
  const originalValidate = window.validateProductCustomizerFields;
  window.validateProductCustomizerFields = function(form) {
    const customizerValid = originalValidate(form);
    const customValid = validateCustomFields(form);
    return customizerValid && customValid;
  };
} else {
  // Si no existe la función del header-cart, crear una básica
  window.validateProductCustomizerFields = function(form) {
    return validateCustomFields(form);
  };
}

// Script para trackear eventos de contacto por WhatsApp
document.addEventListener('DOMContentLoaded', function() {
    
    // Función para enviar evento a Google Analytics
    function trackWhatsAppEvent(eventName, phoneNumber) {
        // Para Google Analytics 4 (gtag)
        if (typeof gtag !== 'undefined') {
            gtag('event', eventName, {
                'event_category': 'whatsapp_contact',
                'event_label': phoneNumber,
                'value': 1
            });
            console.log('Evento enviado a GA4:', eventName);
        }
        
        // Para Universal Analytics (ga) - por compatibilidad
        if (typeof ga !== 'undefined') {
            ga('send', 'event', 'whatsapp_contact', eventName, phoneNumber, 1);
            console.log('Evento enviado a UA:', eventName);
        }
        
        // Para Google Tag Manager (dataLayer)
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                'event': eventName,
                'event_category': 'whatsapp_contact',
                'event_action': 'click',
                'event_label': phoneNumber
            });
            console.log('Evento enviado a GTM:', eventName);
        }
    }
    
    // Mapeo de números de teléfono a nombres de eventos
    const phoneEventMap = {
        '56994536011': 'wp-constructoras',
        '56964041643': 'wp-ferreterias', 
        '56931402052': 'wp-publicogeneral'
    };
    
    // Seleccionar todos los enlaces de WhatsApp
    const whatsappLinks = document.querySelectorAll('a[href^="https://wa.me/"]');
    
    whatsappLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            // Extraer número de teléfono del href
            const href = this.getAttribute('href');
            const phoneMatch = href.match(/wa\.me\/(\d+)/);
            
            if (phoneMatch) {
                const phoneNumber = phoneMatch[1];
                const eventName = phoneEventMap[phoneNumber];
                
                if (eventName) {
                    // Enviar evento a Analytics
                    trackWhatsAppEvent(eventName, phoneNumber);
                    
                    // Pequeño delay para asegurar que el evento se envíe antes de la redirección
                    e.preventDefault();
                    setTimeout(() => {
                        window.open(href, '_blank');
                    }, 100);
                } else {
                    console.warn('Número de WhatsApp no mapeado:', phoneNumber);
                }
            }
        });
    });
    
    console.log('WhatsApp tracking inicializado para', whatsappLinks.length, 'enlaces');
});

// Método alternativo usando selectores más específicos por texto
function initWhatsAppTrackingByText() {
    document.addEventListener('DOMContentLoaded', function() {
        
        // Buscar enlaces por el texto del título
        const constructorasLink = Array.from(document.querySelectorAll('.wa-option')).find(el => 
            el.querySelector('.wa-option-title')?.textContent.trim() === 'Constructoras'
        );
        
        const ferreteriasLink = Array.from(document.querySelectorAll('.wa-option')).find(el => 
            el.querySelector('.wa-option-title')?.textContent.trim() === 'Ferreterías'
        );
        
        const publicoLink = Array.from(document.querySelectorAll('.wa-option')).find(el => 
            el.querySelector('.wa-option-title')?.textContent.trim() === 'Público General'
        );
        
        // Agregar listeners específicos
        if (constructorasLink) {
            constructorasLink.addEventListener('click', function(e) {
                trackWhatsAppEvent('wp-constructoras', '56994536011');
                e.preventDefault();
                setTimeout(() => window.open(this.href, '_blank'), 100);
            });
        }
        
        if (ferreteriasLink) {
            ferreteriasLink.addEventListener('click', function(e) {
                trackWhatsAppEvent('wp-ferreterias', '56964041643');
                e.preventDefault();
                setTimeout(() => window.open(this.href, '_blank'), 100);
            });
        }
        
        if (publicoLink) {
            publicoLink.addEventListener('click', function(e) {
                trackWhatsAppEvent('wp-publicogeneral', '56931402052');
                e.preventDefault();
                setTimeout(() => window.open(this.href, '_blank'), 100);
            });
        }
        
        function trackWhatsAppEvent(eventName, phoneNumber) {
            if (typeof gtag !== 'undefined') {
                gtag('event', eventName, {
                    'event_category': 'whatsapp_contact',
                    'event_label': phoneNumber,
                    'value': 1
                });
            }
            
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    'event': eventName,
                    'event_category': 'whatsapp_contact',
                    'event_action': 'click',
                    'event_label': phoneNumber
                });
            }
            
            console.log('Evento WhatsApp:', eventName);
        }
    });
}

// Manejo del campo de color personalizado - DINÁMICO
document.addEventListener('DOMContentLoaded', function() {
  const customColorField = document.querySelector('input[name="properties[Color]"]');
  
  if (!customColorField) {
    console.log('Custom color field not found');
    return;
  }
  
  // Buscar automáticamente cuál es la opción de color (puede ser índice 0, 1, 2, etc.)
  function findColorOptionIndex() {
    const allSwatches = document.querySelectorAll('.swatch[data-option-index]');
    
    for (let swatch of allSwatches) {
      const header = swatch.querySelector('.header');
      if (header && (
        header.textContent.toLowerCase().includes('color') || 
        swatch.querySelector('input[value="Personalizado"]') ||
        swatch.querySelector('input[value="Color a Elección"]')
      )) {
        return swatch.getAttribute('data-option-index');
      }
    }
    return null;
  }
  
  const colorOptionIndex = findColorOptionIndex();
  
  if (colorOptionIndex === null) {
    console.log('Color option index not found');
    return;
  }
  
  console.log('Found color option at index:', colorOptionIndex);
  
  const colorSwatches = document.querySelectorAll(`.swatch[data-option-index="${colorOptionIndex}"] input[type="radio"]`);
  
  if (colorSwatches.length === 0) {
    console.log('Color swatches not found for index:', colorOptionIndex);
    return;
  }
  
  console.log('Initializing color customization handler for index:', colorOptionIndex);
  
  // Función para manejar el cambio de color
  function handleColorChange() {
    const selectedColor = document.querySelector(`.swatch[data-option-index="${colorOptionIndex}"] input[type="radio"]:checked`);
    
    if (!selectedColor) return;
    
    const selectedValue = selectedColor.value;
    console.log('Color selected:', selectedValue);
    
    // Verificar si es una opción que requiere personalización
    if (selectedValue === 'Personalizado' || selectedValue === 'Color a Elección') {
      // Si selecciona "Personalizado" o "Color a Elección", limpiar el campo y permitir escritura
      customColorField.value = '';
      customColorField.placeholder = 'Ingresa el nombre y código del color aquí';
      customColorField.readOnly = false;
      customColorField.style.backgroundColor = '';
      customColorField.style.cursor = '';
      console.log('Custom color field cleared for personalization');
      
      // Si selecciona "Personalizado", abrir automáticamente el modal
      if (selectedValue === 'Personalizado') {
        console.log('Opening color picker modal for Personalizado option');
        // Verificar si el modal existe antes de abrirlo
        if (typeof $ !== 'undefined' && $('#pickerModal').length > 0) {
          setTimeout(() => {
            $('#pickerModal').modal('show');
          }, 100); // Pequeño delay para asegurar que el campo se actualice primero
        }
      }
    } else {
      // Si selecciona cualquier otro color, poner "N/A" y hacer readonly
      customColorField.value = 'N/A';
      customColorField.placeholder = 'Color predefinido seleccionado';
      customColorField.readOnly = true;
      customColorField.style.backgroundColor = '#f5f5f5';
      customColorField.style.cursor = 'not-allowed';
      console.log('Custom color field set to N/A and readonly');
    }
  }
  
  // Establecer valor inicial al cargar la página
  function initializeColorField() {
    const selectedColor = document.querySelector(`.swatch[data-option-index="${colorOptionIndex}"] input[type="radio"]:checked`);
    
    if (selectedColor && selectedColor.value !== 'Personalizado' && selectedColor.value !== 'Color a Elección') {
      customColorField.value = 'N/A';
      customColorField.placeholder = 'Color predefinido seleccionado';
      customColorField.readOnly = true;
      customColorField.style.backgroundColor = '#f5f5f5';
      customColorField.style.cursor = 'not-allowed';
      console.log('Initial color field set to N/A and readonly');
    } else if (selectedColor && (selectedColor.value === 'Personalizado' || selectedColor.value === 'Color a Elección')) {
      customColorField.value = '';
      customColorField.placeholder = 'Ingresa el nombre y código del color aquí';
      customColorField.readOnly = false;
      customColorField.style.backgroundColor = '';
      customColorField.style.cursor = '';
      console.log('Initial color field cleared for personalization');
    }
  }
  
  // Agregar event listeners a todos los radio buttons de color
  colorSwatches.forEach(function(swatch) {
    swatch.addEventListener('change', handleColorChange);
  });
  
  // También escuchar clics en las etiquetas
  const colorLabels = document.querySelectorAll(`.swatch[data-option-index="${colorOptionIndex}"] label`);
  colorLabels.forEach(function(label) {
    label.addEventListener('click', function() {
      // Pequeño delay para que el radio button se seleccione primero
      setTimeout(handleColorChange, 10);
    });
  });
  
  // Inicializar el campo al cargar
  initializeColorField();
  
  // También verificar después de un pequeño delay por si acaso
  setTimeout(initializeColorField, 100);
});